import React from "react";
import NavBar from "../../components/Navbar/NavBar";
import FooterOne from "../../components/Footer/Footer";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import { sponsorsImages } from "../../utils/BeadsData";


const SponsorsTrips = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box>
            <NavBar />
            <Box
                sx={{
                    mt: 6,
                    backgroundImage: 'url("/assets/img/sponsors/sponsors-cover.jpg")',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    height: '100vh',
                    position: 'relative',
                    zIndex: 1,
                    "&:before": {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0,0,0,0.3)',
                        zIndex: -1,
                    },
                }}
            />

            <Box sx={{ flexGrow: 1, m: 4, textAlign: 'center' }}>
                <Typography variant="h2" gutterBottom align="center" sx={{ mt: 8, mb: 4, fontWeight: 'bold' }}>
                    Sponsors Trips
                </Typography>
                <Typography variant="body1" align="center" sx={{ mb: 4 }}>
                    All sponsors are welcome to visit our schools and the girls in Kenya.
                </Typography>

                <Typography variant="body1" align="center" sx={{ mb: 4 }}>
                    Contact Debby for more information on upcoming trips. Debby is in residence January - March each year.
                </Typography>

                <Swiper
                    modules={[Autoplay, EffectFade]}
                    effect="fade"
                    autoplay={{ delay: 5000, disableOnInteraction: false }}
                    loop={true}
                    style={{
                        width: isMobile ? 'calc(100% - 32px)' : '750px',
                        height: 'auto', borderRadius: '2rem',
                    }}
                    sx={{
                        '.swiper-wrapper': {
                            borderRadius: '2rem',
                        }
                    }}
                >
                    {sponsorsImages.map((image, index) => (
                        <SwiperSlide key={index}>
                            <Box sx={{ position: 'relative' }}>
                                <img src={image.src} alt={image.alt}
                                    style={{ width: '100%', height: 'auto', objectFit: 'contain', borderRadius: '20px' }}
                                />
                                <Typography
                                    variant="subtitle1"
                                    sx={{
                                        position: 'absolute',
                                        bottom: 0,
                                        width: '100%',
                                        color: 'white',
                                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                        padding: '10px',
                                        textAlign: 'center',
                                    }}
                                >
                                    {/* {image.description} */}
                                </Typography>
                            </Box>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </Box>
            <FooterOne />
        </Box>
    );
};

export default SponsorsTrips;